export enum LinksType {
    'link' = 'link',
    'whatsapp' = 'whatsapp',
    'phone' = 'phone',
    'email' = 'email',
    'instagram' = 'instagram',
    'tiktok' = 'tiktok ',
    'facebook' = 'facebook',
    'youtube' = 'youtube',
    'gps' = 'gps',
}
